import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { PhotoAsset } from '../types.ts/story';
import ChatGPTService from '../services/ChatGPTService';
import { generateImagesWithGPT } from '../utility/processGPTData';
import { useVideoCreatorStore } from '../stores-v2/VideoCreatorStoreContext';
import { useDatoClient } from '../stores-v2/StoreContext';

export const useAIPhotoGeneration = () => {
  const videoCreator = useVideoCreatorStore();
  const datoClientStore = useDatoClient();
  const [isGenerating, setIsGenerating] = useState(false);

  const generateAIPhotos = async (prompt: string): Promise<PhotoAsset[]> => {
    if (!prompt.trim()) {
      throw new Error('Prompt cannot be empty');
    }

    try {
      setIsGenerating(true);
      
      const gptService = new ChatGPTService(
        videoCreator,
        datoClientStore.aiPromptRepository,
      );
      
      const arborStylePrompt = await gptService.fetchAiPrompt('Arbor Photo Style');
      const fullPrompt = `${prompt} ${arborStylePrompt?.description || ''}`;

      const result = await generateImagesWithGPT(fullPrompt, 2);
      
      const photoAssets = result?.map((image) => ({
        id: uuid(),
        title: '',
        description: image.alt,
        src: image.url,
        type: 'ai',
      })) as PhotoAsset[];

      return photoAssets;
    } catch (error) {
      console.error('Failed to generate AI photos:', error);
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateAIPhotos,
    isGenerating,
  };
};